import React, { Component } from 'react'
import { graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import he from 'he'
import Link from '../utils/link'
import Seo from '../components/seo'
import SignOff from '../components/sign-off'
import TestimonialCard from '../components/cards/testimonial'
import PropertyCard from '../components/cards/property'
import SearchOverlay from '../components/search-overlay'

class ProfileTemplate extends Component {

  state = {
    headingPlaceholder: `Meet `,
  }

  componentDidMount() {
    this.updateDimensions()
    window.addEventListener("resize", this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  updateDimensions = () => {
    if(window.innerWidth < 900) {
      this.setState({ headingPlaceholder: `Meet` });
    } else {
      this.setState({ headingPlaceholder: `Meet <br />` });
    }
  }

  render() {

    let list = []

    let canSearch = false

    let { headingPlaceholder } = this.state

    let team = this.props.data.wpTeam

    let { sales, wp} = this.props.data

    let { bio, testimonials } = team.acf

    headingPlaceholder = `${headingPlaceholder} ${team.info?.firstName ? team.info?.firstName + ' ' + team.info?.lastName : team.title}`

    return (
      <>
        <Seo title={he.decode(team.seo.title)} bodyClass={team.slug} description={team.seo.metaDesc} />
        <SearchOverlay canSearch={canSearch} list={list} />
        <article className='profile'>

          <div className='profile__inner'>

            <div className='profile__content'>

              <div className='profile__side-menu'>

                <div className='profile__side-menu-upper'>

                  <h4>{ team.title }</h4>

                  <div className='profile__menu'>

                    <ul>

                      { !team.acf.jobTitle && team.info?.position && <li className='position'>{ team.info.position }</li> }
                      { team.acf.jobTitle && <li className='position'>{ team.acf.jobTitle }</li> }

                      { team.info?.email && <li><span className='email'>E</span><Link to={`mailto:${team.info.email}`}>{team.info.email}</Link></li> }
                      { !team.info?.email && team.acf.email && <li><span className='email'>E</span><Link to={`mailto:${team.acf.email}`}>{team.acf.email}</Link></li> }

                      { team.phoneNumbers?.length && team.phoneNumbers?.map((el, i) => {
                        let typeCode = el.typeCode
                        if ( typeCode === 'D' ) typeCode = 'T'
                        if ( typeCode === 'F' ) return
                        return (
                          <li><span className='mobile'>{ el.typeCode }</span><Link to={`tel:${el.number}`}>{el.number}</Link></li>
                        )
                      })}

                      {team.acf.mobile && !team.phoneNumbers && <li><span className='mobile'>M</span><Link to={`tel:${team.acf.mobile}`}>{team.acf.mobile}</Link></li> }
                      {team.acf.phone && !team.phoneNumbers && <li><span className='mobile'>T</span><Link to={`tel:${team.acf.phone}`}>{team.acf.phone}</Link></li> }

                    </ul>

                  </div>

                </div>

                { ( testimonials && sales?.edges?.length > 0 ) &&

                  <div className='profile__side-menu-lower'>

                    <ul>
                      {testimonials &&
                        <li><Link to='#reviews'>Reviews</Link></li>
                      }
                      { sales?.edges?.length > 0 &&
                        <li><Link to='#recent-sales'>Recent Sales</Link></li>
                      }
                    </ul>

                  </div>

                }

              </div>

              <div className='profile__details'>

                <div className='profile__heading'>
                  <h2 dangerouslySetInnerHTML={{ __html: headingPlaceholder }} />
                </div>

                <div className='profile__bio' dangerouslySetInnerHTML={{ __html: bio }} />

              </div>

              <div className='profile__image'>
                { team.acf.profileImage?.localFile &&
                  <GatsbyImage className='team__thumbnail' image={getImage(team.acf.profileImage.localFile)} alt={team.title} />
                }
              </div>

            </div>

          </div>

          { testimonials &&

            <section className='testimonials' id='reviews'>

              <div className='testimonials__inner'>

                <div className='testimonials__content'>

                  <div className='testimonials__menu'>

                    <ul>
                      <li>Reviews</li>
                    </ul>

                  </div>

                  <div className='testimonials__details'>

                    { testimonials.map((el, i) => (
                      <div className='testimonials__item'>
                        <TestimonialCard {...el} />
                      </div>
                    ))}

                  </div>

                </div>

              </div>

            </section>

          }

          { sales?.edges?.length > 0 &&

            <section className='recent-sales' id='recent-sales'>

              <div className='recent-sales__inner'>

                <div className='recent-sales__content'>

                  <div className='recent-sales__menu'>

                    <ul>
                      <li>Recent Sales</li>
                      <li><Link to='/sold/'>View all</Link></li>
                    </ul>

                  </div>

                  <div className='recent-sales__details'>

                    { sales.edges.map((el, i) => (

                      <div className='recent-sales__detail'>

                        <PropertyCard {...el.node} position='' />

                      </div>

                    ))}

                  </div>

                </div>

              </div>

            </section>

          }

          <SignOff {...wp.siteSettings.acf.agentsCta} />

        </article>
      </>
    )
  }
}

export const profileQuery = graphql`
  query ($id: String!, $staffId: Int!) {
    wpTeam(id: {eq: $id}) {
      title
      slug
      seo {
        title
        metaDesc
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          localFile {
            childImageSharp {
              original {
                src
                width
                height
              }
            }
          }
        }
      }
      info {
        id
        firstName
        lastName
        thumbnail
        image
        position
        email
      }
      phoneNumbers {
        comment
        number
        type
        typeCode
      }
      acf {
        profileImage {
          localFile {
            childImageSharp {
              gatsbyImageData(
                quality: 80
                width: 800
                formats: [AUTO, WEBP, AVIF]
                placeholder: DOMINANT_COLOR
              )
            }
          }
        }
        bio
        jobTitle
        mobile
        email
        phone
        testimonials {
          location
          name
          quote
        }
      }
    }
    sales: allWpProperty(
      filter:{
        propertyMeta :{ commercialListingType:{eq:"sale"}, status:{ne:"listing"}, class:{in:["Residential", "Commercial"]}}
        agents: { elemMatch: { id: {in: [$staffId]} } }
      },
      sort: { date: DESC },
      limit: 4
    ) {
      edges {
        node {
          id
          slug
          title
          date
          propertyMeta {
            id
            address {
              suburb {
                postcode
              }
            }
            addressVisibility
            heading
            commercialListingType
            available
            carports
            garages
            openSpaces
            bed
            bath
            landAreaValue
            landAreaUnits
            displayPrice
            displayAddress
            latitude
            longitude
            description
            class
            type
            zoning
            status
          }
          agents {
            staffTypeId
          }
          images {
            url
            thumb_1024
            thumb_180
          }
        }
      }
    }
    wp {
      siteSettings {
        acf {
          agentsCta {
            title
            content
            text
            link
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 75
                    width: 1346
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
            mobileImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    quality: 75
                    width: 332
                    formats: [AUTO, WEBP, AVIF]
                    placeholder: DOMINANT_COLOR
                  )
                }
              }
            }
          }
        }
      }
    }
  }
`

export default ProfileTemplate
